import { PageBreadcrumbContainer } from "lib/page-breadcrumb-container"
import { registerSystemAdminPage } from "routes/sfg20-admin/plugins/system-tab/register-system-admin-page"
import { Settings } from "routes/sfg20-admin/plugins/system-tab/settings-tab/Settings"
import { Tasks } from "routes/sfg20-admin/plugins/system-tab/tasks-tab/tasks"
import { ScheduledTasks } from "routes/sfg20-admin/plugins/system-tab/scheduled-tasks-tab/ScheduledTasks"
import { Jobs } from "routes/sfg20-admin/plugins/system-tab/job-tab/Jobs"
import { AuthBundles } from "routes/sfg20-admin/plugins/system-tab/auth-bundles/auth-bundles.runtime"
import { BundleAndDemandUsage } from "routes/sfg20-admin/plugins/system-tab/bundles-and-demands/bundles-and-demands.runtime"
import {
    PRIORITY_ACCESS,
    PRIORITY_CONFIGURATION,
    PRIORITY_OPERATIONS,
    SECTION_ACCESS,
    SECTION_CONFIGURATION,
    SECTION_OPERATIONS,
} from "routes/sfg20-admin/plugins/system-tab/system-admin-sections"

registerSystemAdminPage({
    name: "Settings",
    path: "settings",
    icon: "mdi:cog",
    priority: PRIORITY_CONFIGURATION,
    group: SECTION_CONFIGURATION,
    content: (
        <PageBreadcrumbContainer hideCrumbs backButton={null} title="Settings">
            <Settings $lazy />
        </PageBreadcrumbContainer>
    ),
})

registerSystemAdminPage({
    name: "Tasks",
    path: "tasks",
    icon: "mdi:format-list-checks",
    priority: PRIORITY_OPERATIONS,
    group: SECTION_OPERATIONS,
    content: (
        <PageBreadcrumbContainer hideCrumbs backButton={null} title="Tasks">
            <Tasks $lazy />
        </PageBreadcrumbContainer>
    ),
})

registerSystemAdminPage({
    name: "Scheduled Tasks",
    path: "scheduled-tasks",
    icon: "mdi:calendar-clock",
    priority: PRIORITY_OPERATIONS + 10,
    group: SECTION_OPERATIONS,
    content: (
        <PageBreadcrumbContainer hideCrumbs backButton={null} title="Scheduled Tasks">
            <ScheduledTasks $lazy />
        </PageBreadcrumbContainer>
    ),
})

registerSystemAdminPage({
    name: "Auth Bundles",
    path: "auth-bundles",
    icon: "mdi:key-chain",
    priority: PRIORITY_ACCESS,
    group: SECTION_ACCESS,
    content: (
        <PageBreadcrumbContainer hideCrumbs backButton={null} title="Auth Bundles">
            <AuthBundles $lazy />
        </PageBreadcrumbContainer>
    ),
})

registerSystemAdminPage({
    name: "Jobs",
    path: "jobs",
    icon: "mdi:briefcase-outline",
    priority: PRIORITY_OPERATIONS + 20,
    group: SECTION_OPERATIONS,
    content: (
        <PageBreadcrumbContainer hideCrumbs backButton={null} title="Jobs">
            <Jobs $lazy />
        </PageBreadcrumbContainer>
    ),
})

registerSystemAdminPage({
    name: "Bundle/Demand Use",
    path: "bundles-and-demands",
    icon: "mdi:chart-box-outline",
    priority: PRIORITY_ACCESS + 10,
    group: SECTION_ACCESS,
    content: (
        <PageBreadcrumbContainer hideCrumbs backButton={null} title="Bundle/Demand Use">
            <BundleAndDemandUsage $lazy />
        </PageBreadcrumbContainer>
    ),
})
